import { SignaturesPage } from "@/pages/SignaturesPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/_app/signatures/')({
  component: SignaturesPage,
})
